import type {
  OpenStoryViewerInput,
  StoryAuthorRef,
} from "@/features/stories/lib/types";

export type InstantsScreen = "viewer" | "camera" | "vault";

export const INSTANTS_SCREENS: readonly InstantsScreen[] = [
  "viewer",
  "camera",
  "vault",
];

export const STORY_COMPOSER_PATH = "/story/new";

export function isInstantsScreen(
  value: string | null,
): value is InstantsScreen {
  return INSTANTS_SCREENS.includes(value as InstantsScreen);
}

export function instantsPath(screen: InstantsScreen) {
  return `/instants/${screen}` as const;
}

export function storyPathForAuthor(author: StoryAuthorRef) {
  const kind = author.highlightId == null ? author.type : "highlight";
  const id = author.highlightId ?? author.id;
  return `/story/${encodeURIComponent(kind)}/${encodeURIComponent(id)}`;
}

export function storyPathForViewer(input: OpenStoryViewerInput) {
  const author = input.authors[input.startAuthorIndex] ?? input.authors[0];
  return author ? storyPathForAuthor(author) : null;
}
